import {Component, Input, ViewEncapsulation} from "@angular/core";
import {Router} from "@angular/router";
import {ServiceItemInterface} from "../../interfaces/service-item.interface";

@Component({
  selector: "sw-service-card",
  templateUrl: "./service-card.component.html",
  encapsulation: ViewEncapsulation.None

})
export class ServiceCardComponent {
  @Input() item!: ServiceItemInterface;


  constructor(
    private router: Router,
  ) {
  }

  onOpenMail(): void {
    const email = "contact@schoonmaakwoede.nl";
    const subject = encodeURIComponent(`Offerte aanvraag ${this.item.header}`);

    const newWindow = window.open(`mailto:${email}?subject=${subject}}`, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  }

  async onRedirect(item: ServiceItemInterface) {
    await this.router.navigate(['/schoonmaakdiensten', item.url])
  }
}
